import React from 'react';
import './investor-theme.css';

/**
 * Class that carries the Manage Investors v2 design system (Hanken Grotesk +
 * the inherited semantic palette and the `--lw-*` component tokens,
 * plus the ported `.lw-*` component classes — see investor-theme.css).
 * Add it to any Radix portal Content (Sheet/Dialog/Select/Popover/Command) that
 * renders OUTSIDE the wrapper subtree so it still inherits the scoped theme.
 */
export const LW_THEME_CLASS = 'lw-investors';

interface InvestorThemeScopeProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wraps Manage Investors v2 in the Loan Center semantic theme. Component tokens apply only
 * within this subtree (`.lw-investors`), so the v2 roster (`DashboardV2`) inherits the portal palette
 * while the rest of the app is unaffected.
 */
export const InvestorThemeScope: React.FC<InvestorThemeScopeProps> = ({ children, className }) => (
  <div className={className ? `${LW_THEME_CLASS} ${className}` : LW_THEME_CLASS}>{children}</div>
);

export default InvestorThemeScope;
